import css from 'styled-jsx/css';
import React from 'react';
import moduleStyles from './progress-bar.module.scss';

type Props = {
  heading: string;
  value: number;
  barColor: string;
};

function getStyles(width: number, barColor: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .bar-value {
      width: ${width}%;
      background-color: ${barColor};
    }
  `;
}

export default function ProgressBar({ heading, value, barColor }: Props) {
  const { className, styles } = getStyles(value, barColor);
  if (Number.isNaN(value)) {
    return null;
  }
  return (
    <div className={`${moduleStyles[`progress-bar-block`]}`} key={heading}>
      {styles}
      <h4>{heading}</h4>
      <div className={moduleStyles.bar}>
        <div className={`${moduleStyles.bar_value} ${className} bar-value fw-bold`}>
          <span className={moduleStyles.barText}>{value}%</span>
        </div>
      </div>
    </div>
  );
}
